export const getTransmission = (name) => {
  if (name.includes('MANUAL')) {
    return ' TM';
  } else if (name.includes('AUTOMATICA')) {
    return ' TA';
  }
  return ` ${name}`;
};


export const cilindrajeFit = (value) => {
  if (value > 0) {
    return ` ${(+value / 1000).toFixed(1)}`;
  }
  return '';
};

export const chargeCapacityFit = (value) => {
  if (value === null) {
    return '';
  }
  if (value > 0) {
    return `${(+value / 1000).toFixed(4)}`;
  }
  return '';
};


export const requiredSelect = (value) => {
  if (value) {
    return null;
  }

  return 'Value  is required';
};
